import React from 'react';
import {CircularProgress, Theme} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import clsx from 'clsx';

const useStyles = makeStyles(() => ({
  loadingRoot: {
    position: 'absolute',
    height: '100%',
    width: '100%',
    top: '0px',
    left: '0px',
    display: 'flex',
    textAlign: 'center',
    //background: 'rgba(0, 0, 0, 0.01)',
    zIndex: 800,
  },
  progress: {
    margin: 'auto',
    width: '60px',
    height: '60px',
  },
  loadingContent: {
    opacity: 0.5,
  }
}));

export const LoadingOverlay = (props: {loading: boolean, children?: any}) => {

  const classes = useStyles();

  return (
      <React.Fragment>
        {props.loading && (
            <div className={classes.loadingRoot}>
              <div className={classes.progress}>
                <CircularProgress />
              </div>
            </div>
        )}
        <div className={clsx(props.loading && classes.loadingContent)}>
          {props.children}
        </div>
      </React.Fragment>
  );
};

export default LoadingOverlay;